import type { Locale } from "../../i18n/locales";

const names: Record<string, Record<Locale, string>> = {
  buiktyfus: {
    nl: "Buiktyfus",
    en: "Typhoid",
    de: "Typhus",
    fr: "Typhoïde",
    es: "Tifoidea",
  },
  chikungunya: {
    nl: "Chikungunya",
    en: "Chikungunya",
    de: "Chikungunya",
    fr: "Chikungunya",
    es: "Chikungunya",
  },
  dengue: {
    nl: "Dengue",
    en: "Dengue",
    de: "Dengue",
    fr: "Dengue",
    es: "Dengue",
  },
  dtp: {
    nl: "DTP",
    en: "DTP",
    de: "DTP",
    fr: "DTP",
    es: "DTP",
  },
  "gele-koorts": {
    nl: "Gele koorts",
    en: "Yellow fever",
    de: "Gelbfieber",
    fr: "Fièvre jaune",
    es: "Fiebre amarilla",
  },
  "hepatitis-a": {
    nl: "Hepatitis A",
    en: "Hepatitis A",
    de: "Hepatitis A",
    fr: "Hépatite A",
    es: "Hepatitis A",
  },
  "hepatitis-b": {
    nl: "Hepatitis B",
    en: "Hepatitis B",
    de: "Hepatitis B",
    fr: "Hépatite B",
    es: "Hepatitis B",
  },
  hoogteziekte: {
    nl: "Hoogteziekte",
    en: "Altitude sickness",
    de: "Höhenkrankheit",
    fr: "Mal des montagnes",
    es: "Mal de altura",
  },
  "japanse-encefalitis": {
    nl: "Japanse encefalitis",
    en: "Japanese encephalitis",
    de: "Japanische Enzephalitis",
    fr: "Encéphalite japonaise",
    es: "Encefalitis japonesa",
  },
  malaria: {
    nl: "Malaria",
    en: "Malaria",
    de: "Malaria",
    fr: "Paludisme",
    es: "Malaria",
  },
  mazelen: {
    nl: "Mazelen",
    en: "Measles",
    de: "Masern",
    fr: "Rougeole",
    es: "Sarampión",
  },
  meningokokken: {
    nl: "Meningokokken",
    en: "Meningococcal",
    de: "Meningokokken",
    fr: "Méningocoque",
    es: "Meningococo",
  },
  muggen: {
    nl: "Muggen",
    en: "Mosquitoes",
    de: "Mücken",
    fr: "Moustiques",
    es: "Mosquitos",
  },
  pest: {
    nl: "Pest",
    en: "Plague",
    de: "Pest",
    fr: "Peste",
    es: "Peste",
  },
  rabies: {
    nl: "Rabiës",
    en: "Rabies",
    de: "Tollwut",
    fr: "Rage",
    es: "Rabia",
  },
  schistosomiasis: {
    nl: "Schistosomiasis",
    en: "Schistosomiasis",
    de: "Schistosomiasis",
    fr: "Schistosomiase",
    es: "Esquistosomiasis",
  },
  tekenencefalitis: {
    nl: "Tekenencefalitis",
    en: "Tick-borne encephalitis",
    de: "FSME",
    fr: "Encéphalite à tiques",
    es: "Encefalitis por garrapatas",
  },
  tuberculose: {
    nl: "Tuberculose",
    en: "Tuberculosis",
    de: "Tuberkulose",
    fr: "Tuberculose",
    es: "Tuberculosis",
  },
};

const lcrUrls: Record<string, string> = {
  buiktyfus: "https://lcr.nl/infectieziekten/4",
  chikungunya: "https://lcr.nl/infectieziekten/8310",
  dengue: "https://lcr.nl/infectieziekten/390",
  dtp: "https://lcr.nl/infectieziekten/3",
  "gele-koorts": "https://lcr.nl/infectieziekten/2",
  "hepatitis-a": "https://lcr.nl/infectieziekten/5",
  "hepatitis-b": "https://lcr.nl/infectieziekten/6",
  hoogteziekte: "https://lcr.nl/infectieziekten/8419",
  "japanse-encefalitis": "https://lcr.nl/infectieziekten/381",
  malaria: "https://lcr.nl/infectieziekten/78",
  mazelen: "https://lcr.nl/infectieziekten/372",
  meningokokken: "https://lcr.nl/infectieziekten/8",
  muggen: "https://lcr.nl/infectieziekten/387",
  pest: "https://lcr.nl/infectieziekten/8461",
  rabies: "https://lcr.nl/infectieziekten/9",
  schistosomiasis: "https://lcr.nl/infectieziekten/394",
  tekenencefalitis: "https://lcr.nl/infectieziekten/384",
  tuberculose: "https://lcr.nl/infectieziekten/375",
};

export function diseaseName(slug: string, locale: Locale): string {
  return names[slug]?.[locale] ?? slug.replaceAll("-", " ");
}

export function diseaseLcrUrl(slug: string): string | undefined {
  return lcrUrls[slug];
}
